import React from 'react';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import FormHelperText from '@mui/material/FormHelperText';

import ChannelToggleContainer from './ChannelToggle.style';

type PropsType = {
  value: string[] | null;
  onChange: (value: string) => void;
  errorText?: string;
  isTouched?: boolean;
};

const ChannelToggle = ({
  value,
  onChange,
  errorText,
  isTouched,
}: PropsType) => {
  const isErrorDisplay = isTouched && Boolean(errorText);
  return (
    <ChannelToggleContainer>
      <ToggleButtonGroup
        color="primary"
        value={value}
        exclusive
        onChange={(_, newValue) => onChange(newValue)}
        aria-label="Channel"
        fullWidth
        sx={{ width: '100%' }}
      >
        <ToggleButton value="sms">SMS</ToggleButton>
        <ToggleButton value="email">EMAIL</ToggleButton>
      </ToggleButtonGroup>
      {isErrorDisplay && (
        <FormHelperText error={isErrorDisplay}>{errorText}</FormHelperText>
      )}
    </ChannelToggleContainer>
  );
};

export default ChannelToggle;
